import { AxiosPromise } from 'axios';
import { URLS } from '@/services/Constants';
import { cloudAxios as axios } from './Authentication';

export default {
  // POST

  /**
   * Reset Password
   *
   * @param {*} data
   * @returns {AxiosPromise<any>}
   */
  resetPassword(data: any): AxiosPromise<any> {
    return axios().request({
      url: URLS().cloudUrlResetPassword,
      method: 'post',
      data,
    });
  },
};
